import { Grid } from '@material-ui/core';
import { ITEM_LABELS_BY_FREIGHT } from '@/components/ShipmentForm/constants/freightTypes';
import { ModalContext } from '../../context';
import { PrimaryButton } from '@/styles/blocks';
import { TabRow, TabTitle } from '../../../../blocks';
import ItemDetails from './ItemDetails';
import React, { memo, useContext, useState } from 'react';

// Stable identity so undirty rows don't get a fresh object every render, which would defeat memo.
const NOT_DIRTY = {};

/**
 * Items section of the Edit Order modal: one `ItemDetails` row per item plus an add button.
 * Takes no props; reads `ModalContext`.
 */
const ItemsEditTab = memo(() => {
    const { state: modalState, callbacks } = useContext(ModalContext);
    const { order, options, isDirty, skus } = modalState;
    const [collapsed, setCollapsed] = useState(false);
    const [applyDispositionToAll, setApplyDispositionToAll] = useState(false);
    const [dispositionToApply, setDispositionToApply] = useState('UNKNOWN');

    const items = order.itemsByOrderId || [];
    // Derived here rather than inside each row: the rows would each need the whole items array,
    // which changes identity on every edit.
    const firstReturnIndex = items.findIndex((item) => item.is_return);

    return (
        <>
            <TabTitle collapsed={collapsed} callbacks={{ setCollapsed }}>
                Items
            </TabTitle>
            {collapsed ? null : (
                <>
                    {items.map((item, idx) => (
                        <ItemDetails
                            key={item.item_id}
                            item={item}
                            index={idx}
                            skus={skus}
                            orderType={order.order_type}
                            freightType={order.freight_type}
                            shipperId={order.shipper_id}
                            oms={order.oms}
                            sourceForm={order.source_form}
                            assemblyRequired={order.assembly_required}
                            isFirstReturnItem={firstReturnIndex >= 0 && firstReturnIndex === idx}
                            editItem={callbacks.editItem}
                            makeItemDirty={callbacks.makeItemDirty}
                            copyItem={callbacks.copyItem}
                            deleteItem={callbacks.deleteItem}
                            editPallet={callbacks.editPallet}
                            applyDispositionToReturns={callbacks.applyDispositionToReturns}
                            isDirty={(isDirty.itemsByOrderId || [])?.[idx] || NOT_DIRTY}
                            startDirty={options.startDirty}
                            applyDispositionToAll={applyDispositionToAll}
                            setApplyDispositionToAll={setApplyDispositionToAll}
                            dispositionToApply={dispositionToApply}
                            setDispositionToApply={setDispositionToApply}
                        />
                    ))}

                    <TabRow>
                        <Grid item>
                            <PrimaryButton onClick={() => callbacks.addItem()}>{`Add ${
                                ITEM_LABELS_BY_FREIGHT[order.freight_type] || 'Item'
                            }`}</PrimaryButton>
                        </Grid>
                    </TabRow>
                </>
            )}
        </>
    );
});

export default ItemsEditTab;
